import { useEffect, useState } from 'react';

import { Flex } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { checkAIReviewCommentsEnabled } from 'utils/helpers/featureFlags';

import { RichTextEditor } from 'uiToolkitV1/RichTextEditor';
import { TextLabel } from 'uiToolkitV1/Typography';

import { MAX_CHARACTERS } from '../ControlledTextField';

const ReviewComment = ({
  label = 'Comments',
  placeholder,
  initialText = '',
  initialTextHTML = '',
  disabled,
  maxCharLimit = MAX_CHARACTERS,
  onBlur = () => {},
  loading,
  showError,
  textGenerationProps = {},
  onChange = null,
  autofocus = false,
  className = 'editor-container',
  providerType,
}) => {
  const [text, setText] = useState(initialTextHTML);
  const [plainText, setPlainText] = useState(initialText);

  useEffect(() => {
    setText(initialTextHTML);
    setPlainText(initialText);
  }, [initialText, initialTextHTML]);

  useEffect(() => {
    if (loading) {
      setText(initialText);
      setPlainText(initialText);
    }
  }, [loading]);

  return (
    <Flex flexDir="column" maxH="350px" minH="220px">
      {label && (
        <TextLabel bold color="text.g2" mb="4px">
          {label}
        </TextLabel>
      )}
      <RichTextEditor
        placeholder={placeholder}
        initialText={text}
        plainText={plainText}
        disabled={disabled}
        maxCharLimit={maxCharLimit}
        onBlur={onBlur}
        onChange={onChange}
        loading={loading}
        showError={showError}
        enableTextGeneration={!isEmpty(textGenerationProps) && checkAIReviewCommentsEnabled()}
        textGenerationProps={textGenerationProps}
        autofocus={autofocus}
        className={className}
        providerType={providerType}
      />
    </Flex>
  );
};

export default ReviewComment;
